import React from 'react';

const ProgressRing = ({ percentage = 0, size = 80, strokeWidth = 6, color = '#1E3A8A' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  const center = size / 2;

  // Color based on percentage if not specified
  const getColor = () => {
    if (color !== '#1E3A8A') return color;
    if (percentage >= 100) return '#16A34A';
    if (percentage >= 60) return '#1E3A8A';
    if (percentage >= 30) return '#F59E0B';
    return '#DC2626';
  };

  return (
    <div className="progress-ring-container" style={{ width: size, height: size, position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#E2E8F0"
          strokeWidth={strokeWidth}
        />
        {/* Progress circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={getColor()}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.5s ease' }}
        />
      </svg>
      <span style={{
        position: 'absolute',
        fontSize: size * 0.22,
        fontWeight: 700,
        color: '#0F172A',
        userSelect: 'none'
      }}>
        {Math.round(percentage)}%
      </span>
    </div>
  );
};

export default ProgressRing;
